jQuery(document).ready(function($) { 



  $(".BlocCenterVideo").fitVids();

  /////// ////// /// //// //
  //  DEBUT AJAX INFINITE SCROOL
if ( $( "#liste-infinite" ).length ) {

      $('#liste-infinite').infinitescroll({
          navSelector: '#page-nav',
          nextSelector: '#page-nav a',
          itemSelector: '.post',
          loading: {
              msgText: 'Chargement des contenus...',
              finishedMsg: 'Aucun contenu à charger.',
              img: 'http://i.imgur.com/6RMhx.gif'
          }
      }, function (newElements) {
          var $newElems = $(newElements);

          $('#liste-infinite').append($newElems);
          
      });

      $('#liste-infinite').infinitescroll('update', {debug: true});
    

      $(window).unbind('.infscr');
      jQuery("#page-nav a").click(function () {
          jQuery('#liste-infinite').infinitescroll('retrieve');
          return false;
      });

      $(document).ajaxError(function (e, xhr, opt) {
          if (xhr.status == 404) $('#page-nav a').remove();
      });  
  }

   function action_on_scroll(){
    if ( $( "#liste-infinite" ).length ) {
      $('#liste-infinite').infinitescroll('scroll');
     }
  }


  /////// ////// /// //// //
  // FIN AJAX ACTUS 

  var slider_bg_equipe = $(".js-SlideEquipeBg");

   if ( $( slider_bg_equipe).length ) {

       slider_bg_equipe.owlCarousel({
       loop:true,
       autoplay:true,
       autoplayTimeout:8000,
       autoplaySpeed:2000,
       navSpeed:2000,
       smartSpeed:2000,
       fluidSpeed:2000,
       margin:0,
       nav:false,
       items:1,
       dots:true,
       mouseDrag:false,
       touchDrag:true,
       // animateIn: 'fadeInDown',
      //    animateOut: 'slideOutLeft'
    });

  }




    $('a.gallery').featherlight({
     // previousIcon: '&#9664;',     /* Code that is used as previous icon */
     // nextIcon: '&#9654;',         /* Code that is used as next icon */
      galleryFadeIn: 100,          /* fadeIn speed when slide is loaded */
      galleryFadeOut: 300 ,         /* fadeOut speed before slide is loaded */
     // iframeMaxWidth: '80%', 
      iframeWidth: 800
    });


  // COUNT UP //

  // var options = {
  //   useEasing: true, 
  //   useGrouping: true, 
  //   separator: ',', 
  //   decimal: '.', 
  // };
  // var $all_number = $(".js-PictoSolution-Big--Number");
  // var demo = new CountUp($all_number, 0, 4589, 0, 2.5, options);
  // if (!demo.error) {
  //   demo.start();
  // console.log('here');
  // } else {
  //   console.error(demo.error);
  // }


  // CLONE MENU HEADER IN JS TO DISPLAY ONLY ON MOBILE //

    var menu_top_for_mobile = $("#secondary-menu").clone().appendTo( ".menu-menu-principal-container" );
    var menu_RS_for_mobile = $(".HeaderSaveNavTop-NavRs").clone().appendTo( ".menu-menu-principal-container" );


  // STICKY HEADER
    // When the user scrolls the page, execute myFunction 
  window.onscroll = function() {myFunction();};

 
  // Get the header
  var header = document.getElementById("masthead");

  // Get the offset position of the navbar
  var sticky = 0;

  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  function myFunction() {
     action_on_scroll();
    if ($(window).width() > 910){
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");
    } else {
      header.classList.remove("sticky");
    }
   }
  }



     var intro_home_bg = $(".js-SlideIntroHome");

   if ( $( intro_home_bg).length ) {

       intro_home_bg.owlCarousel({
       loop:true,
       autoplay:true,
       autoplayTimeout:8000,
       autoplaySpeed:2000,
       navSpeed:2000,
       smartSpeed:2000,
       fluidSpeed:2000,
       margin:0,
       nav:false,
       items:1,
       dots:true,
       mouseDrag:false,
       touchDrag:true,
       // animateIn: 'fadeInDown',
      //    animateOut: 'slideOutLeft'
    });

  }


  

  
  
//  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();
  // WOW EFFECT //


/************************/
/* ECLATE SMART PICOGEN */
/************************/
  if ( $( $("#BigProduitSP-Anim")).length ) {
          
      var controller_smartPico = new ScrollMagic.Controller();
      var offset_truc = parseInt(($("#BigProduitSP-Anim").height() / 2) - 50);
      new ScrollMagic.Scene({triggerElement: "#trigger_smart_pico", duration: 400,offset: offset_truc})
        .setPin("#BigProduitSP-Anim")
        .setClassToggle("#BigProduitSP-Anim", "active")
        //.addIndicators() // add indicators (requires plugin)
        .addTo(controller_smartPico);
      
}


//////////////////////////
  // ECLATE PRODUIT ///

  var EclateProduit = $("#EclateProduit");
  var duration1, duration2, duration3, duration4, offset, faire_eclate;
  function taille_eclate(){
        l_window = $(window).width();
        if (l_window > 1299){
            // duration1 = 50;
            // duration2 = 340;
            // duration3 = 480;
            // duration4 = 50;
            // offset = -80;
            // faire_eclate = true;
            duration1 = 50;
            duration2 = 260;
            duration3 = 360;
            duration4 = 50;
            offset = -20;
            faire_eclate = true;

        }else if(l_window > 1024){
            duration1 = 50;
            duration2 = 260;
            duration3 = 360;
            duration4 = 50;
            offset = -40;
            faire_eclate = true;
        }else{
          faire_eclate = false;
        }
 }

   if ( $( EclateProduit).length ) {

    
    taille_eclate();
     var l_window = $(window).width();
     

    $( window ).resize(function() {
      taille_eclate();
  });

    if (faire_eclate){
      // init controller
      var controller = new ScrollMagic.Controller();

      // LAYER 1 //

      new ScrollMagic.Scene({triggerElement: "#trigger", duration: duration1,offset: offset})
        .setPin("#layer_1")
        .setClassToggle("#layer_1", "no_active")
        //.addIndicators() // add indicators (requires plugin)
        .addTo(controller)
        .on("progress", function (e) {
            if (parseInt(e.progress) == 1){
              $("#layer_1").addClass('active');
            }else{
              $("#layer_1").removeClass('active');
            }
              
          })
        ;

        // new ScrollMagic.Scene({triggerElement: "#trigger", duration: 1200,offset: offset})
        // .setPin(".cadre-eclatement h1")
        // //.addIndicators() // add indicators (requires plugin)
        // .addTo(controller)
        


        new ScrollMagic.Scene({triggerElement: "#trigger", duration: duration2,offset: offset})
        .setPin("#layer_2")
        .setClassToggle("#layer_2", "no_active")
        //.addIndicators() // add indicators (requires plugin)
        .addTo(controller)
        .on("progress", function (e) {
            if (parseInt(e.progress) == 1){
              $("#layer_2").addClass('active');
            }else{
              $("#layer_2").removeClass('active');
            }
              
          })
        ;

        new ScrollMagic.Scene({triggerElement: "#trigger", duration: duration3,offset: offset})
        .setPin("#layer_3") 
        .setClassToggle("#layer_3", "no_active")
        //.addIndicators() // add indicators (requires plugin)
        .addTo(controller)
        .on("progress", function (e) {
            if (parseInt(e.progress) == 1){
              $("#layer_3").addClass('active');
            }else{
              $("#layer_3").removeClass('active');
            }
              
          })
        ;


      //OVERLAY 1
      new ScrollMagic.Scene({triggerElement: "#trigger", duration: duration4,offset: offset})
      .setPin("#overlay-2")
      //.addIndicators() // add indicators (requires plugin)
      .addTo(controller);

    }

  }
//////////////////////////
  // FIN  PRODUIT ///




}); // fin ready menu